<div class="rounded-4 mb-3 position-relative div-shadow h-100 bg-white d-flex flex-column">
  <div *ngIf="paseo?.foto_cabecera_grande" class="image-container pointer" [ngStyle]="{'background-image': 'url(' + paseo?.foto_cabecera_grande + ')'}" (click)="masInformacion()"></div>
  <div class="p-3">
    <div class="mb-2 pointer" (click)="masInformacion()">
      <div class="fw-bold text-iguau fs-4">{{paseo.pa_titulo}}</div>
      <app-leer-mas [texto]="paseo.pa_descripcion" [limite]="80"></app-leer-mas>
    </div>
    <div class="fw-bold text-iguau">Organiza</div>
    <div class="row justify-content-center mb-3 pointer" (click)="masInformacion()">
      <div class="col-auto text-center">
        <img
          *ngIf="paseo?.foto_principal_thumb"
          [src]="paseo?.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
          class="rounded-circle pointer"
          width="50px">
        <div class="text-secondary small">{{paseo.first_name | firstWord}}</div>
      </div>
      <div class="col">
        <div class="row align-items-center">
          <div class="col-auto align-items-top position-relative" *ngFor="let mascota of paseo.mascotas">
            <img
              *ngIf="mascota.foto_principal_thumb"
              [src]="mascota.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
              class="rounded-circle pointer"
              width="50"
              [style.zIndex]="100">
            <div class="text-center small">
              {{mascota.ma_nombre | firstWord}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2 pointer" (click)="masInformacion()">
      <div class="fw-bold text-iguau">Cuando</div>
      <div class="text-secondary mb-2"><i class="fa-regular fa-calendar-days"></i> {{paseo.pa_fecha | cuandoFechas}} a las {{paseo.pa_hora}} <span class="text-danger">{{paseo.pasado ? '(paseo pasado)' : ''}}</span></div>
      <div class="fw-bold text-iguau">Dónde</div>
      <div class="text-secondary"><i class="fa-solid fa-location-dot"></i> {{paseo.pa_ubicacion}}</div>
    </div>
  </div>
  <div class="mt-auto p-3">
    <div class="row align-items-end">
      <div class="col">
        <div *ngIf="paseo.participantes.length == 0">
          <div class="text-secondary">Aún no hay participantes</div>
        </div>
        <div *ngIf="paseo.participantes.length > 0" class="fw-bold text-iguau">
          {{paseo.participantes.length}} {{paseo.participantes.length == 1 ? 'participante' : 'participantes'}}
        </div>
        <div *ngIf="paseo.participante" class="mt-2 badge bg-success"><i class="fa-solid fa-person-walking"></i> Ya participo</div>
      </div>
      <div class="col-auto small" *ngIf="paseos.misdatos.ID == paseo.ID">
        <a class="pointer custom-link a-dark" (click)="editarPaseo(paseo)">
          <i class="fa-solid fa-pencil"></i> Editar
        </a>
      </div>
      <div class="col-auto small text-end text-nowrap">
        <a class="pointer custom-link a-dark" (click)="masInformacion()">
          Leer más <i class="fa-solid fa-angle-right"></i>
        </a>
      </div>
    </div>
  </div>
</div>